import { getPersonalBests } from '../../../../functions/shared/raceMetrics.mjs';

export class PRDetector {
  /** Broad distribution buckets, not PB qualification ranges. */
  static CATEGORIES = {
    '5K': { min: 4.5, max: 5.5 },
    '10K': { min: 9.5, max: 10.5 },
    'Half Marathon': { min: 20.5, max: 22 },
    'Marathon': { min: 41.5, max: 43 },
    'Ultra': { min: 43, max: Infinity },
  };

  static detect(races = []) {
    const bests = getPersonalBests(races || []);
    const winners = new Set(bests.values());
    for (const race of races || []) race.isPR = winners.has(race);
    return new Map([...bests].map(([category, race]) => [category, { raceName: race.raceName, time: race.time, distance: race.distance }]));
  }
}
